(() => {
  const root = document.querySelector('[data-k4y-filter]');
  if (!root) return;
  const apiBase = root.dataset.apiBase.replace(/\/$/u, '');
  const collection = root.dataset.collection;
  const controls = root.querySelector('[data-k4y-controls]');
  const products = root.querySelector('[data-k4y-products]');
  const pages = root.querySelector('[data-k4y-pages]');
  const status = root.querySelector('[data-k4y-status]');
  const sort = root.querySelector('[data-k4y-sort]');
  const nativeGrid = document.querySelector('[data-k4y-native-grid]');
  const drawer = root.querySelector('[data-k4y-drawer]');
  const backdrop = root.querySelector('[data-k4y-backdrop]');
  const openButton = root.querySelector('[data-k4y-open]');
  const selectedCount = root.querySelector('[data-k4y-selected-count]');
  const selection = root.querySelector('[data-k4y-selection]');
  const chips = root.querySelector('[data-k4y-chips]');
  const filterParams = () => new URLSearchParams(window.location.search);
  const cardNodes = new Map();
  const cardRequests = new Map();
  let requestId = 0;

  for (const card of document.querySelectorAll('[data-k4y-native-grid] #product-grid > li')) {
    const href = card.querySelector('.card__media a[href*="/products/"]')?.getAttribute('href');
    if (href) {
      const handle = new URL(href, window.location.origin).pathname.split('/products/')[1];
      if (handle) cardNodes.set(decodeURIComponent(handle), card);
    }
  }

  const desktopSidebar = window.matchMedia('(min-width: 990px)');
  const hasSidebar = root.classList.contains('k4y-filter--focus');
  function syncSidebar() {
    if (!hasSidebar) return;
    const open = desktopSidebar.matches;
    drawer.hidden = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    openButton.setAttribute('aria-expanded', String(open));
    backdrop.hidden = true;
    document.body.classList.remove('k4y-filter-drawer-open');
  }
  desktopSidebar.addEventListener('change', syncSidebar);
  syncSidebar();

  function setDrawer(open) {
    if (hasSidebar && desktopSidebar.matches) { syncSidebar(); return; }
    drawer.hidden = !open;
    backdrop.hidden = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    openButton.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('k4y-filter-drawer-open', open);
    if (open) root.querySelector('[data-k4y-close]').focus();
    else openButton.focus();
  }

  function element(tag, text, className) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  }

  function changeFilter(key, value) {
    const url = new URL(window.location.href);
    if (value) url.searchParams.set(`f.${key}`, value);
    else url.searchParams.delete(`f.${key}`);
    url.searchParams.delete('page');
    history.replaceState(null, '', url);
    load();
  }

  function renderSelection(data) {
    const query = filterParams();
    const active = [];
    const decimal = value => new Intl.NumberFormat('de-DE', { maximumFractionDigits: 3 }).format(value);
    const money = value => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
    for (const field of data.filters) {
      const raw = query.get(`f.${field.key}`);
      if (!raw) continue;
      const label = field.key === 'hersteller' ? 'Marke' : field.label;
      if (field.type !== 'number') {
        for (const value of raw.split('|').filter(Boolean)) {
          active.push({
            text: `${label}: ${value}`,
            remove: () => changeFilter(field.key, raw.split('|').filter(item => item !== value).join('|'))
          });
        }
        continue;
      }
      const [min, max] = raw.split(':').map(Number);
      if (!Number.isFinite(min) || !Number.isFinite(max)) continue;
      if (field.key === 'preis') {
        active.push({ text: `${money(min)} - ${money(max)}`, remove: () => changeFilter(field.key, null) });
        continue;
      }
      const unit = field.unit ? ` ${field.unit}` : '';
      if (min === max) {
        active.push({ text: `${label}: ${decimal(min)}${unit}`, remove: () => changeFilter(field.key, null) });
        continue;
      }
      const bounds = data.facets.numbers.find(item => item.key === field.key);
      if (bounds && min > bounds.min) {
        active.push({
          text: `${label}: ab ${decimal(min)}${unit}`,
          remove: () => changeFilter(field.key, bounds.min === max ? null : `${bounds.min}:${max}`)
        });
      }
      if (bounds && max < bounds.max) {
        active.push({
          text: `${label}: bis ${decimal(max)}${unit}`,
          remove: () => changeFilter(field.key, min === bounds.max ? null : `${min}:${bounds.max}`)
        });
      }
      if (!bounds || (min <= bounds.min && max >= bounds.max)) {
        active.push({ text: `${label}: ${decimal(min)}–${decimal(max)}${unit}`, remove: () => changeFilter(field.key, null) });
      }
    }
    chips.replaceChildren();
    for (const item of active) {
      const chip = element('button', undefined, 'k4y-filter__chip');
      chip.type = 'button';
      chip.setAttribute('aria-label', `${item.text} entfernen`);
      chip.append(document.createTextNode(item.text));
      const cross = element('span', '×', 'k4y-filter__chip-cross');
      cross.setAttribute('aria-hidden', 'true');
      chip.append(cross);
      chip.addEventListener('click', item.remove);
      chips.append(chip);
    }
    selection.hidden = active.length === 0;
    root.classList.toggle('k4y-filter--selected', active.length > 0);
    selectedCount.hidden = active.length === 0;
    selectedCount.textContent = `(${active.length})`;
  }

  function numericFacet(field, bounds, selected) {
    if (bounds?.min == null || bounds?.max == null) return null;
    const wrapper = element('details', undefined, 'k4y-filter__facet');
    const summary = element('summary', field.label);
    const inner = element('div', undefined, 'k4y-filter__ranges');
    const values = element('div', undefined, 'k4y-filter__range-values');
    const track = element('div', undefined, 'k4y-filter__range-track');
    track.append(element('span', undefined, 'k4y-filter__range-fill'));
    const step = field.unit === 'Zoll' ? 0.015625 : field.unit === 'EUR' ? 0.01 : 0.1;
    const current = selected?.split(':').map(Number) || [bounds.min, bounds.max];
    const sliders = [], numbers = [];
    const constant = bounds.min === bounds.max;
    function paint() {
      const span = bounds.max - bounds.min || 1;
      track.style.setProperty('--range-start', `${(Number(sliders[0].value) - bounds.min) / span * 100}%`);
      track.style.setProperty('--range-end', `${(Number(sliders[1].value) - bounds.min) / span * 100}%`);
    }
    function update(i, value, commit) {
      let v = Math.max(bounds.min, Math.min(bounds.max, Number(value)));
      if (!Number.isFinite(v)) return;
      v = i === 0 ? Math.min(v, Number(sliders[1].value)) : Math.max(v, Number(sliders[0].value));
      sliders[i].value = String(v); numbers[i].value = String(v);
      // Bring the lower handle to the front when both handles meet at the maximum.
      track.classList.toggle('k4y-filter__range-track--lower-front', Number(sliders[0].value) === bounds.max);
      paint();
      if (commit) {
        const a = Number(sliders[0].value), b = Number(sliders[1].value);
        changeFilter(field.key, a === bounds.min && b === bounds.max ? null : `${a}:${b}`);
      }
    }
    for (const [i, labelText] of ['Von', 'Bis'].entries()) {
      const label = element('label', `${labelText}${field.unit ? ` (${field.unit})` : ''}`);
      const number = document.createElement('input'); number.type = 'number'; number.inputMode = 'decimal';
      const slider = document.createElement('input'); slider.type = 'range';
      for (const input of [number, slider]) {
        input.min = String(bounds.min); input.max = String(bounds.max); input.step = String(step); input.value = String(current[i]); input.disabled = constant;
        input.setAttribute('aria-label', `${field.label} ${labelText}${input === number ? ' eingeben' : ''}`);
      }
      sliders.push(slider); numbers.push(number); label.append(number); values.append(label); track.append(slider);
      slider.addEventListener('input', () => update(i, slider.value, false));
      slider.addEventListener('change', () => update(i, slider.value, true));
      number.addEventListener('change', () => update(i, number.value, true));
    }
    paint(); inner.append(values, track); wrapper.append(summary, inner); return wrapper;
  }

  function textFacet(field, options, selected) {
    if (!options?.length) return null;
    const wrapper = element('details', undefined, 'k4y-filter__facet');
    const summary = element('summary', field.key === 'hersteller' ? 'Marke' : field.label);
    const inner = element('div', undefined, 'k4y-filter__facet-options');
    const chosen = new Set((selected || '').split('|').filter(Boolean));
    for (const option of [...options].sort((a, b) => new Intl.Collator('de', { numeric: true, sensitivity: 'base' }).compare(a.value, b.value))) {
      const label = element('label');
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.value = option.value;
      checkbox.checked = chosen.has(option.value);
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) chosen.add(checkbox.value);
        else chosen.delete(checkbox.value);
        changeFilter(field.key, [...chosen].join('|'));
      });
      label.append(checkbox, document.createTextNode(`${option.value} (${option.count})`));
      inner.append(label);
    }
    wrapper.append(summary, inner);
    return wrapper;
  }

  function renderControls(data) {
    const query = filterParams();
    const expanded = new Set([...controls.querySelectorAll('details[open]')].map(node => node.dataset.field));
    controls.replaceChildren();
    sort.value = query.get('sort_by') || 'manual';
    const order = hasSidebar ? ['kaeltemittel', 'arbeitsbereich', 'hersteller', 'preis', 'spannung', 'spannungsfrequenz'] : ['hersteller', 'preis', 'profilbreite', 'profilhoehe', 'konfiguration'];
    const fields = [...data.filters].sort((a, b) => {
      const aRank = order.indexOf(a.key);
      const bRank = order.indexOf(b.key);
      return (aRank < 0 ? order.length : aRank) - (bRank < 0 ? order.length : bRank);
    });
    let facetTarget = controls;
    if (hasSidebar) {
      const brandField = fields.find(field => field.key === 'hersteller');
      if (brandField) {
        const label = element('label', undefined, 'k4y-filter__manufacturer');
        label.append(element('span', root.dataset.labelBrand || 'Hersteller', 'visually-hidden'));
        const select = document.createElement('select');
        select.setAttribute('aria-label', root.dataset.labelBrand || 'Hersteller');
        const all = element('option', root.dataset.labelAllBrands || 'Alle Hersteller');
        all.value = '';
        select.append(all);
        const currentBrand = query.get('f.hersteller') || '';
        const options = data.facets.hersteller || [];
        for (const item of options) {
          const option = element('option', item.value);
          option.value = item.value;
          select.append(option);
        }
        if (currentBrand && !options.some(item => item.value === currentBrand)) {
          const option = element('option', currentBrand.split('|').join(', '));
          option.value = currentBrand;
          select.append(option);
        }
        select.value = currentBrand;
        select.addEventListener('change', () => changeFilter('hersteller', select.value));
        label.append(select);
        controls.append(label);
      }
      const extra = element('div', undefined, 'k4y-extra-filters');
      extra.dataset.k4yExtraFilters = '';
      extra.append(element('h3', root.dataset.labelMoreFilters || 'Weitere technische Filter'));
      controls.append(extra);
      facetTarget = extra;
    }
    for (const field of fields) {
      if (hasSidebar && field.key === 'hersteller') continue;
      const selected = query.get(`f.${field.key}`);
      const facet = field.type === 'number'
        ? numericFacet(field, field.key === 'preis' ? data.facets.preis : data.facets.numbers.find(x => x.key === field.key), selected)
        : textFacet(field, field.key === 'hersteller' ? data.facets.hersteller : data.facets.text.filter(x => x.key === field.key), selected);
      if (facet) {
        facet.dataset.field = field.key;
        facet.open = expanded.has(field.key) || (hasSidebar && !!selected);
        facetTarget.append(facet);
      }
    }
  }

  async function getCard(handle) {
    if (cardNodes.has(handle)) return cardNodes.get(handle);
    if (!cardRequests.has(handle)) {
      const route = window.Shopify?.routes?.root || '/';
      const url = new URL(`${route}products/${encodeURIComponent(handle)}`, window.location.origin);
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      url.searchParams.set('section_id', hasSidebar ? 'k4y-focus-product-card' : 'k4y-product-card');
      cardRequests.set(handle, fetch(url, { credentials: 'same-origin' }).then(async response => {
        if (!response.ok) throw new Error(`Card HTTP ${response.status}`);
        const html = await response.text();
        const card = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-k4y-card]');
        if (!card || card.dataset.k4yHandle !== handle) throw new Error('Card section unavailable');
        cardNodes.set(handle, card);
        return card;
      }).catch(error => {
        cardRequests.delete(handle);
        throw error;
      }));
    }
    return cardRequests.get(handle);
  }

  function renderProducts(data, current) {
    products.replaceChildren();
    if (!data.products.length) {
      const empty = element('li', undefined, 'k4y-filter__error');
      empty.append(element('p', root.dataset.labelSelectionEmpty || 'Keine passenden Produkte gefunden.'));
      if (hasSidebar) {
        const advice = element('a', root.dataset.labelAdvice);
        advice.href = '#K4YAdviceForm';
        empty.append(advice);
      }
      products.append(empty);
      return;
    }
    const items = data.products.map(product => {
      const placeholder = element('li', 'Produkt wird geladen …', 'grid__item k4y-filter__loading');
      products.append(placeholder);
      return { product, placeholder };
    });
    let next = 0;
    let errors = 0;
    const worker = async () => {
      while (next < items.length && current === requestId) {
        const { product, placeholder } = items[next++];
        try {
          const card = await getCard(product.handle);
          if (current === requestId) placeholder.replaceWith(card);
        } catch (_) {
          if (current !== requestId) return;
          errors += 1;
          const route = window.Shopify?.routes?.root || '/';
          const fallback = element('li', undefined, 'grid__item k4y-filter__error');
          const link = element('a', product.title);
          link.href = `${route}products/${encodeURIComponent(product.handle)}`;
          fallback.append(link);
          placeholder.replaceWith(fallback);
        }
      }
    };
    Promise.all(Array.from({ length: Math.min(6, items.length) }, worker)).then(() => {
      if (current !== requestId) return;
      // BSS detects newly inserted collection prices through its lazy-product scroll listener.
      // Let the installed app calculate and reveal prices; never override its visibility rules.
      window.dispatchEvent(new Event('scroll'));
      if (errors) status.textContent = `${data.total} Produkte · ${errors} Kacheln konnten nicht geladen werden`;
    });
  }

  function renderPages(data) {
    pages.replaceChildren();
    const totalPages = Math.max(1, Math.ceil(data.total / 24));
    if (hasSidebar) {
      if (totalPages < 2) return;
      const list = element('ul', undefined, 'pagination__list list-unstyled');
      list.setAttribute('role', 'list');
      const addPage = (target, label, arrow) => {
        const item = document.createElement('li');
        const link = element('a', arrow ? undefined : String(target), 'pagination__item link');
        link.setAttribute('aria-label', label);
        if (target === data.page && !arrow) {
          link.classList.add('pagination__item--current', 'light');
          link.setAttribute('aria-current', 'page');
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('role', 'link');
        } else {
          const url = new URL(window.location.href);
          if (target === 1) url.searchParams.delete('page');
          else url.searchParams.set('page', String(target));
          url.hash = 'k4y-katalog';
          link.href = url.href;
          link.addEventListener('click', event => {
            if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            history.replaceState(null, '', url);
            load();
            document.getElementById('k4y-katalog')?.scrollIntoView({ behavior: 'smooth' });
          });
        }
        if (arrow) {
          link.classList.add('pagination__item-arrow', arrow === 'previous' ? 'pagination__item--next' : 'pagination__item--prev');
          const icon = element('span', undefined, 'svg-wrapper');
          const template = root.querySelector(arrow === 'previous' ? '[data-k4y-page-previous]' : '[data-k4y-page-next]');
          if (template) icon.append(template.content.cloneNode(true));
          link.append(icon);
        }
        item.append(link);
        list.append(item);
      };
      if (data.page > 1) addPage(data.page - 1, root.dataset.labelPrevious || 'Vorherige Seite', 'previous');
      const numbers = new Set([1, totalPages]);
      for (let n = Math.max(1, data.page - 1); n <= Math.min(totalPages, Math.max(3, data.page + 1)); n++) numbers.add(n);
      let previous = 0;
      for (const number of [...numbers].sort((a, b) => a - b)) {
        if (previous && number - previous > 1) {
          const item = document.createElement('li');
          item.append(element('span', '…', 'pagination__item'));
          list.append(item);
        }
        addPage(number, (root.dataset.labelPage || 'Seite __number__').replace('__number__', String(number)));
        previous = number;
      }
      if (data.page < totalPages) addPage(data.page + 1, root.dataset.labelNext || 'Nächste Seite', 'next');
      pages.append(list);
      return;
    }
    for (const [text, target, disabled] of [
      ['Zurück', data.page - 1, data.page <= 1],
      ['Weiter', data.page + 1, data.page >= totalPages]
    ]) {
      const button = element('button', text);
      button.type = 'button';
      button.disabled = disabled;
      button.addEventListener('click', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('page', String(target));
        history.replaceState(null, '', url);
        load();
        root.scrollIntoView({ behavior: 'smooth' });
      });
      if (text === 'Weiter') pages.append(element('span', `Seite ${data.page} von ${totalPages}`));
      pages.append(button);
    }
  }

  async function load() {
    const current = ++requestId;
    if (!root.hidden) status.textContent = 'Produkte werden geladen …';
    const params = filterParams();
    if (hasSidebar && params.has('k4y_power')) {
      if (nativeGrid) nativeGrid.hidden = true;
      root.hidden = false;
      const featured = root.querySelector('[data-k4y-featured]');
      if (featured) featured.hidden = true;
      products.replaceChildren(element('li', root.dataset.labelSelectionLoading, 'k4y-filter__loading'));
    }
    const remote = new URL(`${apiBase}/index.php`);
    remote.searchParams.set('collection', collection);
    for (const [key, value] of params) if (key.startsWith('f.') || key === 'page' || key === 'sort_by') remote.searchParams.append(key, value);
    try {
      const response = await fetch(remote);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      let data = await response.json();
      if (hasSidebar && params.has('k4y_power')) {
        if (!window.K4YSelection) throw new Error('selection-unavailable');
        status.textContent = root.dataset.labelSelectionLoading;
        const technicalProducts = await window.K4YSelection.load(collection, new URL(location.href));
        data = window.K4YSelection.apply(technicalProducts, params, data);
      }
      if (current !== requestId) return;
      const featured = root.querySelector('[data-k4y-featured]');
      if (featured) featured.hidden = [...params.keys()].some(k => k.startsWith('f.')) || Number(params.get('page') || 1) > 1;
      renderControls(data);
      renderSelection(data);
      renderProducts(data, current);
      renderPages(data);
      status.textContent = params.has('k4y_power')
        ? root.dataset.labelSelectionCount.replace('__count__', data.total)
        : `${data.total} Produkte`;
      document.dispatchEvent(new Event('k4y:selection-change'));
      if (nativeGrid) nativeGrid.hidden = true;
      root.hidden = false;
    } catch (_) {
      if (current === requestId && params.has('k4y_power')) {
        if (nativeGrid) nativeGrid.hidden = true;
        root.hidden = false;
        products.replaceChildren(element('li', root.dataset.labelSelectionError, 'k4y-filter__error'));
        pages.replaceChildren();
        status.textContent = root.dataset.labelSelectionError;
      } else if (current === requestId && !root.hidden) status.textContent = 'Die Filter sind vorübergehend nicht verfügbar. Bitte laden Sie die Seite erneut.';
    }
  }

  const resetFilters = () => {
    const url = new URL(window.location.href);
    for (const key of [...url.searchParams.keys()]) if (key.startsWith('f.') || key.startsWith('k4y_') || key === 'page') url.searchParams.delete(key);
    history.replaceState(null, '', url);
    load();
  };
  root.querySelector('[data-k4y-reset]').addEventListener('click', resetFilters);
  root.querySelector('[data-k4y-clear]').addEventListener('click', resetFilters);
  root.querySelector('[data-k4y-chip-left]').addEventListener('click', () => chips.scrollBy({ left: -260, behavior: 'smooth' }));
  root.querySelector('[data-k4y-chip-right]').addEventListener('click', () => chips.scrollBy({ left: 260, behavior: 'smooth' }));
  for (const button of root.querySelectorAll('[data-k4y-desktop-columns], [data-k4y-mobile-columns]')) {
    button.addEventListener('click', () => {
      const mobile = button.hasAttribute('data-k4y-mobile-columns');
      const key = mobile ? 'mobileColumns' : 'desktopColumns';
      const attribute = mobile ? 'data-k4y-mobile-columns' : 'data-k4y-desktop-columns';
      root.dataset[key] = button.getAttribute(attribute);
      for (const peer of root.querySelectorAll(`[${attribute}]`)) peer.setAttribute('aria-pressed', String(peer === button));
    });
  }
  openButton.addEventListener('click', () => setDrawer(true));
  root.querySelector('[data-k4y-close]').addEventListener('click', () => setDrawer(false));
  root.querySelector('[data-k4y-apply]').addEventListener('click', () => setDrawer(false));
  backdrop.addEventListener('click', () => setDrawer(false));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !drawer.hidden) setDrawer(false);
  });
  sort.addEventListener('change', () => {
    const url = new URL(window.location.href);
    if (sort.value === 'manual') url.searchParams.delete('sort_by');
    else url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    history.replaceState(null, '', url);
    load();
  });
  window.addEventListener('popstate', load);
  load();
})();

